import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Contract from "../Pages/Admin/Contract";
import ContractEdit from "../Pages/User/Contract";
import Merchant from "../Pages/Admin/Merchant";
import Vendor from "../Pages/Admin/Vendor";
import Users from "../Pages/Admin/Users";
import MFASettings from "../Pages/Admin/MFA";
import { useUserContext } from "../Contexts/user";

const AdminRoutes = () => {
  const { userData } = useUserContext();

  return (
    <Routes>
      <Route path="/admin/contracts" element={<Contract />} />
      <Route path="/admin/contracts/:id/edit" element={<ContractEdit />} />
      {userData?.role === "admin" && (
        <Route path="/admin/merchants" element={<Merchant />} />
      )}
      {(userData?.role === "admin" || userData?.role === "merchant") && (
        <Route path="/admin/vendors" element={<Vendor />} />
      )}
      {(userData?.role === "admin" ||
        userData?.role === "merchant" ||
        userData?.assistant === true) && (
        <Route path="/admin/users" element={<Users />} />
      )}
      <Route path="/admin/mfa" element={<MFASettings />} />
      <Route path="*" element={<Navigate to="/admin/contracts" />} />
    </Routes>
  );
};

export default AdminRoutes;
